import { Alert, AlertProps } from "@mui/material";

import AppIcon from "../Icons/AppIcon";

export interface AppAlertProps extends AlertProps {}

export function AppAlert({ severity, children, ...otherProps }: AppAlertProps) {
  return (
    <Alert
      severity={severity}
      icon={severity === "text" ? <AppIcon of='info' /> : undefined}
      {...otherProps}
    >
      {children}
    </Alert>
  );
}
